import DialogTitle, { type DialogTitleProps } from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import { fontScale } from '@theme';
import { CloseButton } from '../../../buttons/CloseButton';
import { useLaptopLayoutAndUp } from '../../../utils';
import Title from './Title';

type Props = {
  titleAction?: React.ReactNode;
  titleIcon?: React.ReactNode;
  title?: string | React.ReactElement<any>;
  closeAction?: React.MouseEventHandler<HTMLButtonElement>;
} & Omit<DialogTitleProps, 'title'>;

export default ({
  titleAction,
  titleIcon,
  title,
  closeAction,
  ...props
}: Props) => {
  const laptopLayout = useLaptopLayoutAndUp();

  return (
    <DialogTitle
      data-testid="dialog-title"
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pb: 1,
        fontSize: laptopLayout ? `${fontScale[2]}rem` : `${fontScale[1]}rem`,
        color: (theme) => theme.palette.text.header,
      }}
      component={laptopLayout ? 'h2' : 'div'}
      {...props}
    >
      <Title title={title} titleIcon={titleIcon} />
      <Stack direction="row" sx={{ gap: 2 }}>
        {titleAction}
        <CloseButton onClick={closeAction} />
      </Stack>
    </DialogTitle>
  );
};
